// src/features/eventos/domain/armasIndex.js
import { norm } from "./eventoUtils";

export const armaSearchText = (a) =>
    norm(
        [
            a?.tipoArmaDescripcion,
            a?.tipo,
            a?.marca,
            a?.modelo,
            a?.calibreDescripcion,
            a?.calibre,
            a?.numeroGuia,
            a?.numeroSerie,
            a?.numero,
            a?.pais,
            a?.paisDescripcion,
            a?.propietarioNombre,
            a?.titularNombre,
            a?.propietario?.nombre,
            a?.propietario?.apellidos,
            a?.titular?.nombre,
            a?.titular?.apellidos,
            a?.observaciones,
        ]
            .filter(Boolean)
            .join(" ")
    );

export const armaLabel = (a) => {
    const tipoRaw = String(a?.tipoArmaDescripcion ?? a?.tipo ?? "").trim();
    const tipo3 = tipoRaw ? tipoRaw.slice(0, 3) : "—";

    const calibre = String(a?.calibre ?? "—").trim() || "—";
    const serie = String(a?.numeroSerie ?? "—").trim() || "—";

    return `${tipo3} • ${calibre} • ${serie}`;
};

export const buildArmasIndex = (armas) => {
    const base = Array.isArray(armas) ? armas : [];
    const map = new Map();

    base.forEach((a) => {
        if (a?.id != null) {
            const id = Number(a.id);
            map.set(id, {
                ...a,
                _id: id,
                _label: armaLabel(a),
                _search: armaSearchText(a),
            });
        }
    });

    return Array.from(map.values());
};
